import {
  anexarArquivoEmItem,
  criarRequisicaoTerceiros,
} from "../../services/compras";

/**
 * Manda os itens de terceiros de uma lista para o setor de Compras.
 *
 * Dois passos porque o upload é 1 arquivo por request — é o único padrão
 * multipart que existe neste projeto, e inventar "N arquivos numa request"
 * criaria um caminho sem precedente para manter. Então: cria a requisição com
 * os textos (transação única no backend) e sobe os anexos em seguida, por item.
 *
 * Falha de anexo NÃO derruba o envio: a requisição já existe e o comprador já
 * consegue trabalhar com descrição + tipo + observações. Perder o pedido
 * inteiro porque um PDF falhou seria pior do que ficar sem o PDF — e o item
 * fica visível sem anexo, o que é um sinal claro do que precisa ser reenviado.
 *
 * Devolve `{ requisicao, anexosComFalha }`; `null` quando não havia terceiros.
 */
export async function enviarTerceirosDaLista(request, listaId, terceiros) {
  if (!terceiros || !terceiros.length) return null;

  const requisicao = await criarRequisicaoTerceiros(request, listaId, terceiros);
  const itensCriados = requisicao?.itens || [];
  const anexosComFalha = [];

  // Os itens voltam na mesma ordem em que foram enviados (o backend cria em
  // sequência), então o índice casa. Ainda assim, guarda de tamanho: se algum
  // dia o backend reordenar, é melhor pular o anexo do que anexar no item errado.
  for (let i = 0; i < terceiros.length; i += 1) {
    const arquivo = terceiros[i]?.arquivo;
    const item = itensCriados[i];
    if (!arquivo || !item) continue;
    try {
      await anexarArquivoEmItem(request, requisicao.id, item.id, arquivo);
    } catch {
      anexosComFalha.push(terceiros[i].descricao);
    }
  }

  return { requisicao, anexosComFalha };
}
